import { ITransportAccessibility } from '../../types/newbuilding/transportAccessibility';
import { TApplicationState } from '../../types/redux';

export const getTransportAccessibility = (state: TApplicationState): ITransportAccessibility | null => {
  const { transportAccessibility } = state.newbuilding;

  if (!transportAccessibility) {
    return null;
  }

  return transportAccessibility.transport || null;
};
